/*
Authentication related implementation
*/
import axios from "axios";
import serverSelect from "../serverSelect";
import authHeader from "./auth-header";

const API_URL = `${serverSelect()}`;

export const login = (username, password) => {
    const data = {
        username: username,
        password: password,
    };
    return axios
        .post(API_URL + "/api/token_auth/", data)
        .then((response) => {
            if (response.data.token) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const register = (username, password, organisation) => {
    const data = {
        username: username,
        password: password,
        organisation: organisation,
    };
    return axios
        .post(API_URL + "/api/register/", data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const validateEmail = (email) => {
    return axios
        .get(API_URL + "/api/validate/agent/", {"params": {"email": email}})
        .then((response) => {
            return true;
        })
        .catch((error) => {
            return false;
        });
}

export const resetPass = (username) => {
    const data = {
        username: username,
    };

    return axios
        .post("/api/password_reset/", data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const changePass = (user) => {
    const data = {
        username: user.userData.username,
    };
    return axios.post(
        "/api/password_change/",
        data,
        authHeader(user)
    );
};

export const getUserData = (user) => {
    return axios.get(API_URL + "api/current_user/", authHeader(user));
};

export default {
    login,
    getUserData,
    register,
    resetPass,
    changePass,
    validateEmail
};
